import { MTM_SUBMIT_FEEDBACK } from './constants';

export function submitMtmFeedback() {
  return { type: MTM_SUBMIT_FEEDBACK };
}
